<template>
  <div class="footer pt-3">
    <div class="container">
      <div class="row text-white">
        <div class="col-md-3">
          <img src="@/assets/logo.png" class="logo" />
          <p>
            Boost your business with an all-in-one vessel management software,
            providing full control and visibility over your fleet by integrating
            technical, commercial, financial, and analytical operations in one
            platform.
          </p>
          <h5>Follow Us</h5>
          <div class="row mt-3">
            <div class="col-2">
              <a
                href="https://www.linkedin.com/company/maritech-software"
                target="_blank"
              >
                <i class="bi bi-linkedin box-icon text-white"></i>
              </a>
            </div>
            <div class="col-2">
              <a
                href="https://x.com/maritechone"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i class="bi bi-twitter-x box-icon text-white"></i>
              </a>
            </div>
          </div>
        </div>
        <div class="col-md-2 mt-4">
          <p>Quick Links</p>
          <ul>
            <li><i class="bi bi-arrow-right"></i> Home</li>
            <li><i class="bi bi-arrow-right"></i> About Us</li>
            <li><i class="bi bi-arrow-right"></i> Contact Us</li>
            <li><i class="bi bi-arrow-right"></i> Services</li>
            <li>
              <i class="bi bi-arrow-right"></i>
              Our Team
            </li>
          </ul>
        </div>
        <div class="col-md-3 mt-4">
          <p>Popular Post</p>

          <div class="image-text-container">
            <img
              src="@/assets/TechnicalModule.webp"
              class="img-fluid picture"
            />
            <router-link to="/maritechone-technical-module" class="text-style">
              MeritechOne Technical Module
            </router-link>
          </div>
          <hr class="hr-new" />

          <div class="image-text-container">
            <img
              src="@/assets/CommercialModule.webp"
              class="img-fluid picture"
            />
            <router-link to="/maritechone-qhse-module" class="text-style">
              MaritechOne QHSE Module
            </router-link>
          </div>
        </div>
        <div class="col-md-2 mt-4">
          <p>Contact Info</p>
          <p><i class="bi bi-geo-alt circle-icon"></i> Location</p>
          <p><i class="bi bi-envelope-at-fill circle-icon"></i> Email Us</p>
          <p><i class="bi bi-telephone-inbound circle-icon"></i> Phone Us</p>
        </div>
        <div class="col-md-2 mt-4">
          <P>Support</P>
          <router-link
            to="/maritech-one-demo-request"
            class="btn btn-theme-invert w-100 mb-2"
          >
            Request a demo
          </router-link>

          <a
            href="https://support.maritechsoftware.com"
            target="_blank"
            class="btn btn-theme-invert w-100"
          >
            Customer Portal
          </a>
        </div>
      </div>
      <hr class="hr-new1" />
      <div class="row">
        <div class="col-md-6">
          <p class="text-white">
            &copy; 2024 Maritech Software All Rights Reserved.
          </p>
        </div>
        <div class="col-md-6 text-end text-white">
          <p class="word-space">
            <a
              href="https://maritechsoftware.com/privacy"
              target="_blank"
              rel="noopener noreferrer"
              class="text-white text-decoration"
              >Privacy Policy |</a
            >

            Contact Us
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.footer {
  background-color: #024caa;
  font-family: lato, sans-serif;
  display: flex;
  position: relative;
}

.logo {
  max-width: 150px;
}

ul {
  list-style: none;
  padding: 0;
}

li {
  line-height: 200%;
  font-family: lato, sans-serif;
}
.picture {
  width: 100px;
  height: auto;
}
.hr-new {
  border: 1px solid #ffff;
}
.circle-icon {
  background: #0d92f4;
  padding: 10px;
  border-radius: 50%;
  line-height: 3rem;
}
.box-icon {
  background: #0d92f4;
  padding: 10px;
  border-radius: 10%;
}
.hr-new1 {
  border-top: 2px solid #ffff;
}
.word-space {
  font-family: lato, sans-serif;
  color: white;
}
.text-decoration {
  text-decoration: none;
}
.image-text-container {
  display: flex;
  align-items: center;
  gap: 20px;
}
.text-style {
  font-size: 16px;
  color: white;
  text-decoration: none;
}
.btn-request {
  background-color: #5b99c2;
  color: #091057;
  font-weight: 600;
}
.btn-request:hover {
  background-color: rgb(113, 159, 199);
  display: flex;
}
.btn-outline-primary {
  border-width: 2px;
  color: white;
  display: flex;
  margin-top: 1rem;
}
a {
  text-decoration: none;
}
</style>
